import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { debounce, get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { compose } from 'recompose'
import { Input, Radio, RadioGroup, Select } from 'components/fields'
import { participants } from 'constants/wizards'
import { wizard } from 'helpers/decorators'
import {
  apiCommon,
  apiAwardUnits,
  apiParticipants,
  apiRegistrations,
  apiConfiguration,
  apiLocales
} from 'helpers/decorators/api'
import { meta } from 'helpers/decorators'
import { Button, Note, Title } from 'components/misc'
import { generalSelectMap } from 'redux/selectors/misc'
import { createMapAwardUnits } from 'redux/selectors/award-units'
import validate from './welcome.validation'
import { CONFIGURATION_KEYS } from 'constants/enums'
import { connect } from 'react-redux'
import config from '../../../../config'
import queryString from 'query-string'
import { initializeFormFields } from '../../../../helpers/formInitializationHelper'


const asyncValidate = (val, dispatch, props) => {
  const { values } = props

  if (!get(values, 'helpers.awardLeaderEmail')) {
    return new Promise(resolve => resolve())
  }
  const checkPayload = {
    email: get(values, 'helpers.awardLeaderEmail'),
    awardUnitId: get(values, 'organizationId')
  }

  /* eslint-disable */
  return props.checkLeader(checkPayload)
  .then(() => {})
  .catch(() => { throw {
    helpers: {
      awardLeaderEmail: {
        text: "Leader doesn't exist",
        intlKey: 'errors.leader_doesnt_exist'
      }
    }
  }
  })
  /* eslint-enable */
}

let mapAwardUnits

const enhance = compose(
  apiCommon({
    publicCountries: true,
    rejectEmpty: true
  }),
  apiAwardUnits(),
  apiParticipants(),
  apiRegistrations(),
  apiConfiguration(),
  apiLocales(),
  connect(
    ({ api }) => ({
        initData: get(api, 'registrations.initData'),
        registrationInfo: get(api, 'participants.registrationInfo')
    }), {}
  ),
  wizard({
    form: 'participantRegistration',
    multipage: true,
    destroyOnUnmount: false,
    validate,
    asyncValidate,
    disableHook: true,
    asyncBlurFields: ['helpers.awardLeaderEmail']
  }),
  meta({
    title: 'Register participant',
    intlKey: 'pageTitle.register_participant'
  })
)

class Welcome extends Component {
  static propTypes = {
    awardUnits: PropTypes.object,
    changeWizardActive: PropTypes.func.isRequired,
    getAwardQuestions: PropTypes.func.isRequired,
    changeWizardNext: PropTypes.func.isRequired,
    onGetConfigurationValues: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    onFetchAwardUnits: PropTypes.func,
    leaderId: PropTypes.number,
    onSubmit: PropTypes.func,
    links: PropTypes.any,
    values: PropTypes.object,
    common: PropTypes.object,
    checkOperatingAuthorities: PropTypes.func,
    locales: PropTypes.object,
    changeLocale: PropTypes.func,
    loadRegistrationLocales: PropTypes.func.isRequired,
    onGetRegistrationInitData: PropTypes.func.isRequired,
    initData: PropTypes.object,
    registrationInfo: PropTypes.object,
    getRegistrationInfo: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
    notification: PropTypes.func.isRequired,
    handleGetRegistrationFieldsCustomization: PropTypes.func
  }

  constructor(props) {
    super(props)
    mapAwardUnits = createMapAwardUnits()
    this.handleWizardUpdate = debounce(this.handleWizardUpdate, 1000)
    this.state = {
      awardUnits: [],
      organizationLanguage: undefined,
    }
  }

  componentDidMount = async() => {
    const { match, getRegistrationInfo } = this.props
    const query = queryString.parse(get(this.props, 'location.search'))
    const authorizationCode = get(query, 'authorizationCode')
    const globalId = get(match, 'params.ecode')

    if (authorizationCode) {
      try {
        const result = await getRegistrationInfo(authorizationCode)
        const registration = result.body
        const organizationId = get(registration, 'organizationId', null)
        const awardLeaderId = get(registration, 'awardLeaderId', null)

        let id = null

        if (awardLeaderId) {
          id = `AL${awardLeaderId}`
        } else if (organizationId) {
          id = `AU${organizationId}`
        }

        id && await this.props.onGetRegistrationInitData(id)
      } catch (err) {
        const errorCode = get(err, 'body') && JSON.parse(err.body).errorCode

        if (errorCode === 'UNAUTHORIZED') {
          this.props.notification(
            'Authorisation code is not valid - it looks like you have previously used this code',
            {
              intlKey: 'notifications.authorization_code_is_not_valid',
              status: 'error'
            }
          )
          this.props.push(`${config.publicPath}/`)
        }
      }
    } else if (globalId) {
      globalId && await this.props.onGetRegistrationInitData(globalId)
    }
  }

  componentWillReceiveProps = async (nextProps)=> {
    if(get(this.props, 'initData.auId') !== get(nextProps, 'initData.auId')) {
      const countryId = get(nextProps, 'initData.countryId')
      const selectedCountry = this.handleGetSelectedCountry(countryId)
      const oaId = get(nextProps, 'initData.oaId')
      const soaId = get(nextProps, 'initData.soaId')
      const auId = get(nextProps, 'initData.auId')
      const awardLeaderEmail = get(nextProps, 'initData.awardLeaderEmail')

      let fieldsToInit = [
        { name: 'countryId', value: countryId },
        { name: 'organizationId', value: auId },
      ]

      if (oaId) {
        await this.props.checkOperatingAuthorities({ countryId: countryId, name: '' }).then(res => {
          const operatingAuthorities = get(res, 'body')

          const selectedOa = operatingAuthorities && operatingAuthorities.filter(item => item.id === oaId)[0]

          fieldsToInit = [
            ...fieldsToInit,
            // Helpers
            { name: 'helpers.selectedCountry', value: selectedCountry },
            { name: 'helpers.operatingAuthorities', value: operatingAuthorities },
            { name: 'helpers.selectedOa', value: selectedOa },
            { name: 'helpers.operatingAuthorityId', value: oaId },
          ]
        })
      }

      if (soaId) {
        await this.props.onFetchAwardUnits({ countryId: countryId }, { parentOrganizationId: soaId }).then(res => {

          const awardUnits = get(res, 'body')

          fieldsToInit = [
            ...fieldsToInit,
            // Helpers
            { name: 'helpers.awardUnits', value: awardUnits },
            { name: 'helpers.subOperatingAuthorityId', value: soaId },
          ]
        })
      } else {
        await this.props.onFetchAwardUnits({ countryId: countryId }, { parentOrganizationId: oaId }).then(res => {
          const awardUnits = get(res, 'body')

          fieldsToInit = [
            ...fieldsToInit,
            // Helpers
            { name: 'helpers.awardUnits', value: awardUnits },
          ]
        })
      }

      if (awardLeaderEmail) {
        fieldsToInit = [
          ...fieldsToInit,
          // Helpers
          { name: 'helpers.knownLeader', value: 'yes' },
          { name: 'helpers.awardLeaderEmail', value: awardLeaderEmail },
        ]
      } else {
        fieldsToInit = [
          ...fieldsToInit,
          // Helpers
          { name: 'helpers.knownLeader', value: 'no' },
          { name: 'helpers.awardLeaderEmail', value: null },
        ]
      }

      initializeFormFields(this.props, fieldsToInit)
    }
    if (this.props.leaderId !== nextProps.leaderId) {
      this.props.change('awardLeaderId', nextProps.leaderId)
    }
  }

  componentDidUpdate(prevProps) {
    const orgId = get(this.props.values, 'organizationId', null)
    const prevOrgId = get(prevProps.values, 'organizationId', null)

    if (orgId && orgId !== prevOrgId) {
      this.handleLoadFieldCustomizations(orgId)
      this.handleUpdateWizardData(orgId)
    }
  }

  handleUpdateWizardData = async orgId => {
    const [questionsRes, wizardCfg] = await Promise.all([
      this.getAwardQuestions(orgId),
      this.getWizardCustomizations(orgId)
    ])

    const profileDescRes = this.applyProfileQuestionDesc(
      get(wizardCfg, `values.${CONFIGURATION_KEYS.participantRegProfileQuestionDesc.id}.textValue`)
    )

    const skipPaymentRes = Boolean(
      get(wizardCfg, `values.${CONFIGURATION_KEYS.participantRegistrationSkipPayment.id}.booleanValue`)
    )

    this.handleWizardUpdate(questionsRes || profileDescRes, skipPaymentRes)
  };

  /**
   * All four keys belong to the same organization, so they are loaded in a single call
   */
  getWizardCustomizations = orgId =>
    orgId && this.props.onGetConfigurationValues([
      CONFIGURATION_KEYS.participantRegProfileQuestionDesc.id,
      CONFIGURATION_KEYS.participantRegistrationSkipPayment.id,
      CONFIGURATION_KEYS.participantRegistrationSkipPaymentSilver.id,
      CONFIGURATION_KEYS.participantRegistrationSkipPaymentGold.id
    ], orgId)

  getAwardQuestions = async(orgId) => {
    const res = orgId && await this.props.getAwardQuestions(orgId)

    return Boolean(get(res, 'body[0].translationKey'))
  }

  handleGetSelectedCountry = value =>
    get(this.props.common, 'countries.data', []).filter(
      item => item.id === value
    )[0]

  applyProfileQuestionDesc = pqDesc => {
    if (Boolean(pqDesc)) {
      this.props.change('helpers.profileQuestionsDesc', pqDesc)
      return true
    }
    return false
  }

  handleLoadFieldCustomizations = async(orgId) => {
    orgId && await this.props.handleGetRegistrationFieldsCustomization(orgId)
  }

  handleFetchAwardUnits = ({ countryId, organizationId, parentOrganizationId } = {}) => {
    return this.props
      .onFetchAwardUnits(
        { countryId },
        {
          organizationId,
          parentOrganizationId
        }
      )
      .then(({ body }) => {
        this.props.change('helpers.awardUnits', body)
      })
  }

  hideLanguageSteps = () => {
    const { steps, rootPath } = participants

    this.props.changeWizardActive(steps.language.id, false)
    this.props.changeWizardNext(steps.welcome.id, rootPath + steps.level.path)
  }

  handleSelectCountry = async({ value } = {}) => {
    if (!value) {
      this.props.change('helpers', {})
      return
    }

    const selectedCountry = this.handleGetSelectedCountry(value)
    const isPresentNao = get(selectedCountry, 'isPresentNao', false)
    const naoId = get(selectedCountry, 'naoId', false)
    const isPresentOa = get(selectedCountry, 'isPresentOa', false)
    const isPresentIc = get(selectedCountry, 'isPresentIc', false)

    if (isPresentNao && naoId) {
      // Both keys belong to the same organization (the NAO), so they are loaded in a single call
      const naoCustomization = await this.props.onGetConfigurationValues(
        [
          CONFIGURATION_KEYS.enableOperatingAuthority.id,
          CONFIGURATION_KEYS.participantRegistrationAwardLeader.id
        ],
        naoId
      )

      this.handleNaoLoaded(value, {
        enableOperatingAuthority: get(
          naoCustomization,
          `values.${CONFIGURATION_KEYS.enableOperatingAuthority.id}.booleanValue`
        ),
        participantRegistrationAwardLeader: get(
          naoCustomization,
          `values.${CONFIGURATION_KEYS.participantRegistrationAwardLeader.id}.booleanValue`
        )
      })
    } else {
      this.handleNaoLoaded(value)
    }

    if (isPresentIc && isPresentOa) {
      this.handleFetchAUsAndIACs()
    }

    const orgRegLocales = await this.props.loadRegistrationLocales(naoId)

    if (orgRegLocales && orgRegLocales.length > 0) {
      const locales = orgRegLocales.map(i => { return get(i, 'locale') })

      if (locales.length === 1) {
        this.hideLanguageSteps()
        this.setState({
          organizationLanguage: get(locales[0], 'id')
        })
      } else {
        const { steps, rootPath } = participants

        this.props.changeWizardActive(steps.language.id, true)
        this.props.changeWizardNext(steps.welcome.id, rootPath + steps.language.path)
        this.props.change('helpers.orgRegLocales', locales)
      }
    } else {
      this.hideLanguageSteps()
    }
  }

  handleNaoLoaded = (value, { enableOperatingAuthority = true, participantRegistrationAwardLeader = true } = {}) => {
    const selectedCountry = this.handleGetSelectedCountry(value)
    const isPresentOa = get(selectedCountry, 'isPresentOa', false)

    if (isPresentOa && enableOperatingAuthority) {
      this.handleCheckOperatingAuthority({
        countryId: value,
        name: ''
      })
    } else {
      this.handleFetchAwardUnits({
        countryId: value,
        organizationId: get(this.props.values, 'helpers.filterAusById', null)
      })
    }

    this.props.change('helpers', {})
    this.props.change('helpers.filterAusById', '')
    this.props.change('organizationId', '')
    this.props.change('helpers.selectedCountry', selectedCountry)
    this.props.change(
      'helpers.country.enableOperatingAuthority',
      enableOperatingAuthority
    )
    this.props.change(
      'helpers.participantRegistrationAwardLeader',
      participantRegistrationAwardLeader
    )
  }

  handleResetAwardLeaderEmail = () => {
    this.props.change('helpers.awardLeaderEmail', '')
  }
  handleCheckOperatingAuthority = params => {
    get(params, 'name') &&
      this.props.change(
        'helpers.lastSearchedOperatingAuthority',
        get(params, 'name')
      )

    return this.props.checkOperatingAuthorities(params).then(res => {
      this.props.change('helpers.operatingAuthorities', get(res, 'body'))

      return res
    })
  }

  handleChangeOA = ({ value } = {}) => {
    const { values } = this.props

    if (!value) {
      this.props.change('helpers.selectedOa', {})
    }

    const operatingAuthorities = get(values, 'helpers.operatingAuthorities', [])

    this.props.change('helpers.filterAusById', value)

    if (operatingAuthorities.length === 0) {
      return
    }

    const selectedOa = operatingAuthorities.filter(item => item.id === value)[0]

    const isPresentSoa =
      get(selectedOa, 'subOperatingAuthorities', []).length > 0

    if (!isPresentSoa && value) {
      this.handleFetchAwardUnits({
        countryId: get(values, 'countryId', null),
        parentOrganizationId: get(selectedOa, 'id', null)
      })
    }

    this.props.change('helpers.selectedOa', selectedOa)
  }

  handleChangeSOA = ({ value } = {}) => {
    const { values } = this.props

    if (!value) {
      return
    }

    this.handleFetchAwardUnits({
      countryId: get(values, 'countryId', null),
      parentOrganizationId: value
    })

    this.props.change('helpers.filterAusById', value)
  }

  handleWizardUpdate = async (shouldShowProfile, skipPayment) => {
    const { steps, rootPath } = participants
    const { links } = this.props
    const parent = links.findEntry(item => item.id === steps.parent.id)

    if (shouldShowProfile !== undefined) {
      if (shouldShowProfile) {
        const detailsNext = parent[1].active
          ? steps.parent.path
          : steps.profile.path

        this.props.changeWizardActive(steps.profile.id, true)
        this.props.changeWizardNext(steps.details.id, rootPath + detailsNext)
        this.props.changeWizardNext(
          steps.parent.id,
          rootPath + steps.profile.path
        )
        this.props.change('helpers.hasProfileQuestions', true)
      } else {
        const detailsNext = parent[1].active
          ? steps.parent.path
          : steps.payment.path

        this.props.changeWizardActive(steps.profile.id, false)
        this.props.changeWizardNext(steps.details.id, rootPath + detailsNext)
        this.props.changeWizardNext(
          steps.parent.id,
          rootPath + steps.payment.path
        )
        this.props.change('helpers.hasProfileQuestions', false)
      }
    }

    if (skipPayment) {
      this.props.changeWizardActive(steps.payment.id, false)
    }
  }

  handleChangeIac = () => {
    this.props.change('helpers.operatingAuthorityId', '')
    this.props.change('helpers.subOperatingAuthorityId', '')
    this.props.change('helpers.selectedOa', '')
    this.props.change('helpers.lastSearchedOperatingAuthority', '')
    this.props.change('organizationId', '')

    this.handleFetchAwardUnits({
      countryId: get(this.props.values, 'countryId', null)
    })
  }

  handleFetchAUsAndIACs = () => {
    this.props.change('helpers.operatingAuthorityId', '')
    this.props.change('helpers.subOperatingAuthorityId', '')
    this.props.change('helpers.selectedOa', '')
    this.props.change('helpers.lastSearchedOperatingAuthority', '')
    this.props.change('organizationId', '')

    const countryId = get(this.props.values, 'countryId', null)

    return this.props.onFetchAwardUnits({ countryId })
      .then(({ body }) => {
        this.props.change('helpers.awardUnits', body)
      })
  }

  handleOnSubmit = () => {
    const { organizationLanguage } = this.state
    const { onSubmit, locales, changeLocale } = this.props

    if (organizationLanguage) {
      const updateLocale = locales.data.filter(item => item.id === organizationLanguage)[0]

      try {
        changeLocale(updateLocale)
      } catch (err) {
        console.log(err)
      }
    }

    onSubmit()
  }


  render() {
    const { awardUnits, handleSubmit, values, initData, common } = this.props
    const countryId = get(values, 'countryId')
    // const leaderEmail = get(values, 'helpers.awardLeaderEmail')
    const awardUnitId = get(values, 'organizationId')
    const lastSearched = get(values, 'helpers.lastSearchedOperatingAuthority')
    const isIac = get(values, 'helpers.isIac') === true

      const participantRegistrationAwardLeader = get(
      values,
      'helpers.participantRegistrationAwardLeader'
    )

    const enableOperatingAuthority = get(
      values,
      'helpers.country.enableOperatingAuthority'
    )

    const isPresentIc = get(
      values,
      'helpers.selectedCountry.isPresentIc',
      false
    )

    const isPresentOa = get(
      values,
      'helpers.selectedCountry.isPresentOa',
      false
    )

    const awardUnitsList = get(values, 'helpers.awardUnits', [])

    const isPresentSoa =
      get(values, 'helpers.selectedOa.subOperatingAuthorities', []).length > 0

    const mappedAUs = mapAwardUnits(awardUnitsList, {
      isIac,
      isPresentOa,
      isPresentIc
    })

    const hideSubOrgs = isPresentIc && isPresentOa
    const oaList = get(values, 'helpers.operatingAuthorities', [])
    const oaId = get(initData, 'oaId')
    const soaId = get(initData, 'soaId')
    const awardLeaderEmail = get(initData, 'awardLeaderEmail')
    const awardLeaderEmailOnRegistrationVisible = get(initData, 'awardLeaderEmailOnRegistrationVisible')

    return (
      <form
        onSubmit={handleSubmit(this.handleOnSubmit)}
        data-testId="registrationWelcomeForm"
      >
        <Title h1>
          <FormattedMessage
            id="moduleTitle.welcome_to_the_orb"
            defaultMessage="Welcome to the Online Record Book"
          />
        </Title>

        <Note lighter margin="0 0 35px 0">
          <FormattedMessage
            id="label.you_are_now_registering_as_participant"
            defaultMessage="You are now registering as an Award participant"
          />
        </Note>
        <div className="row">
          <div className="col-xs-12 col-sm-6">
            <Select
              label="Select country"
              intlKey="label.select_country"
              name="countryId"
              options={common.countries.list}
              onSelectChange={this.handleSelectCountry}
              searchable
              loading={get(common, 'countries.loading')}
              dataTestId="selectCountryDropdown"
            />

            {((!hideSubOrgs && isPresentOa && !isIac && enableOperatingAuthority)
                || oaId) &&
              <Select
                label="Select your Operating Authority"
                intlKey="label.select_your_operating_authority"
                name="helpers.operatingAuthorityId"
                loading={countryId && values && !oaList.length}
                disabled={!countryId || !values || !oaList.length}
                onSelectChange={this.handleChangeOA}
                options={generalSelectMap(
                  get(values, 'helpers.operatingAuthorities', [])
                )}
                autoloadValue={lastSearched}
              />}

            {((!hideSubOrgs && isPresentSoa && !isIac && enableOperatingAuthority)
              || soaId) &&
              <Select
                label="Select sub Operating Authority"
                name="helpers.subOperatingAuthorityId"
                intlKey="label.select_sub_operating_authority"
                placeholder="Start typing..."
                intlKeyPlaceholder="label.start_typing"
                options={generalSelectMap(
                  get(values, 'helpers.selectedOa.subOperatingAuthorities', [])
                )}
                onSelectChange={this.handleChangeSOA}
                searchable
              />}

            <Select
              key={countryId}
              label="Select your award unit"
              intlKey="label.select_your_award_unit"
              name="organizationId"
              options={mappedAUs}
              loading={awardUnits.loadingUnits}
              disabled={
                (!countryId ||
                  !values ||
                  (isPresentOa &&
                    !get(values, 'helpers.operatingAuthorityId') &&
                    !isIac &&
                    enableOperatingAuthority) ||
                  (isPresentSoa &&
                    !get(values, 'helpers.subOperatingAuthorityId') &&
                    !isIac &&
                    enableOperatingAuthority)) &&
                    !hideSubOrgs
              }
              onSelectChange={this.handleResetAwardLeaderEmail}
              searchable
              dataTestId="selectAwardUnitDropdown"
            />

            {(participantRegistrationAwardLeader || awardLeaderEmail || awardLeaderEmailOnRegistrationVisible) &&
            <RadioGroup
              label="Do you know who is your Award Leader?"
              intlKey="label.do_you_know_who_is_your_award_leader"
              name="helpers.knownLeader"
              horizontal
              disabled={!countryId || !awardUnitId}
              {...this.props}
            >
              <Radio
                label="Yes"
                intlKey="button.yes"
                name="helpers.knownLeader"
                value="yes"
                dataTestId="radioKnowAwardLeaderEmail"
              />
              <Radio
                label="No"
                intlKey="button.no"
                name="helpers.knownLeader"
                value="no"
                onChange={this.handleResetAwardLeaderEmail}
                dataTestId="radioDontKnowAwardLeaderEmail"
              />
            </RadioGroup>}

            {get(values, 'helpers.knownLeader') === 'yes' &&
              <div>
                <Input
                  label="Enter his email"
                  intlKey="label.enter_his_email"
                  name="helpers.awardLeaderEmail"
                  disabled={!awardUnitId || !values}
                  dataTestId="knownAwardLeaderEmail"
                />
              </div>}
          </div>
        </div>
        <div>
          <Button type="submit">
            <FormattedMessage id="button.continue" defaultMessage="Continue" />
          </Button>
        </div>
      </form>
    )
  }
}

export default enhance(Welcome)
